import { webinar } from "../../../datasets/webinars";
import { StandardFormComponent } from "../../components/FormComponent";
import { FiTv } from "react-icons/fi";

export const WebinarVideoForm = ({ setFlagPresent }) => {
  return (
    <section className="webinar_video_form-background">
      <FiTv className="webinar_video_form-icon" />
      <section className="webinar_video_form-container">
        <p className="webinar_video_form-header">{webinar.form.header}</p>
        <StandardFormComponent
          data={webinar.form}
          setFlagPresent={setFlagPresent}
          pipedriveType="View Webinar"
          formName="Webinar video"
          gaName="Webinar Video"
          isConsent={false}
        />
      </section>
    </section>
  );
};
